let flagsCssLoadPromise: Promise<unknown> | null = null;

export const ensureFlagsCssLoaded = () => {
  if (!flagsCssLoadPromise) {
    flagsCssLoadPromise = import("../flags.css").catch((error) => {
      console.error("Failed to load flags.css", error);
      flagsCssLoadPromise = null;
      throw error;
    });
  }

  return flagsCssLoadPromise;
};
